module.exports = {
  install(Vue) {
    Vue.prototype.shuffleImage = {
      init(count) {
        const imageStart = 1;
        const imageEnd = 6360;
        const arr = [];
        for (let i = 0; i < count; i += 1) {
          const rand = Math.floor((Math.random() * ((imageEnd - imageStart) + 1)) + imageStart);
          arr.push(rand);
        }
        return arr;
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/plugins/shuffle_image.js